<template>
	<div @mouseover="playVideo" @mouseout="stopVideo">
		<youtube :video-id="youtube" :playerVars="{'rel': 0, 'showinfo': 0}"
				 class="video" ref="youtube">
		</youtube>
	</div>
</template>

<script>


	export default {
		props: ['youtube'],

		methods: {
			async playVideo() {
				this.$refs.youtube.player.mute();

				await this.$refs.youtube.player.playVideo();
			},

			stopVideo() {
				this.$refs.youtube.player.pauseVideo();
			}
		},

		mounted() {

			function onYouTubeIframeAPIReady() {
				player = new YT.Player(node, {
					height: playerHeight,
					width: playerWidth,
					playerVars: {'rel': 0, 'showinfo': 0, 'hidecontrols': 1 },
					events: {
						'onReady': loadVideo
					}
				});
			}
		}
	};
</script>

